(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      // JS Menu Intact (Ne Touche Pas, Comme Demande)
      const menuOverlay = document.querySelector('.menu-drawer__overlay');
      if (menuOverlay) {
        const closeDrawer = () => {
          const drawerDetails = document.getElementById('Details-menu-drawer-container');
          if (drawerDetails) drawerDetails.removeAttribute('open');
          menuOverlay.style.display = 'none';
          menuOverlay.style.opacity = '0';
          document.body.classList.remove('menu-drawer-open');
          document.body.style.overflow = 'auto';
        };
        menuOverlay.addEventListener('click', closeDrawer);
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          const openDetails = document.querySelectorAll('details[open]');
          openDetails.forEach(d => d.removeAttribute('open'));
          const overlay = document.querySelector('.menu-drawer__overlay');
          if (overlay) overlay.style.display = 'none';
          document.body.classList.remove('menu-drawer-open');
          document.body.style.overflow = 'auto';
        }
      });

      const hamburger = document.querySelector('.header__icon--menu summary');
      if (hamburger) {
        hamburger.addEventListener('click', (e) => {
          const drawerDetails = document.getElementById('Details-menu-drawer-container');
          const isOpen = drawerDetails.hasAttribute('open');
          const overlay = document.querySelector('.menu-drawer__overlay');
          if (isOpen) {
            document.body.classList.add('menu-drawer-open');
            if (overlay) overlay.style.display = 'block';
          } else {
            setTimeout(() => {
              document.body.classList.remove('menu-drawer-open');
              document.body.style.overflow = 'auto';
              if (overlay) overlay.style.display = 'none';
            }, 10);
          }
        });
      }

      // Pas de JS pour Sélecteurs (Supprimés)
    }

    // ... (setHeaderHeight, disconnectedCallback, createObserver, onScroll, hide, reveal, reset, closeMenuDisclosure, closeSearchModal identiques à précédent, sans selector focus)

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu, header-drawer details');
      this.disclosures.forEach(disclosure => {
        if (disclosure.tagName === 'DETAILS') {
          disclosure.removeAttribute('open');
        } else {
          disclosure.close();
        }
      });
      // Pas de selector close (supprimé)
      const overlay = document.querySelector('.menu-drawer__overlay');
      if (overlay) overlay.style.display = 'none';
      document.body.classList.remove('menu-drawer-open');
      document.body.style.overflow = 'auto';
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
